// extracted by mini-css-extract-plugin
export default {"linksContainer":"DashboardMenu_linksContainer__Tr9tb","menuLink":"DashboardMenu_menuLink__UtXZA","activeLink":"DashboardMenu_activeLink__yBypY"};